import pmpDashboard from './pmp-dashboard';
import pmpApplication from './pmp-application';
import pmpAbout from './pmp-about';

// ===========================|| MENU ITEMS ||=========================== //

const MenuItems = {
    items: [pmpDashboard, pmpApplication, pmpAbout]
};

export default MenuItems;
